import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import PartiesFormProperties from './PartiesFormProperties'
import { FormProvider, useForm } from 'react-hook-form'
import useCustomYupValidationResolver from '../../../components/aciacehighway/hooks/useCustomYupValidationResolver'
import { Box, Card, Grid, Tooltip } from '@material-ui/core'
import NaCommonTranslationText from 'src/common/NaCommonTranslationText'
import ACEHighwayManifestTranslationText from '../contexts/ACEHighwayManifestTranslationText'

const {
  button: { CngButton, CngIconButton }
} = components

const { initialValues, makeValidationSchema } =
  PartiesFormProperties.formikProps

function PartiesEntry(props) {
  const {
    isLast,
    onAddParties,
    onDeleteParties,
    onEditParties,
    parties,
    showNotification
  } = props

  const { translate } = useTranslation(Namespace.ACE_HIGHWAY_ABI_INBOND_7512)
  const methods = useForm({
    defaultValues: parties || initialValues,
    resolver: useCustomYupValidationResolver(makeValidationSchema(translate))
  })
  const manifestTranslatedTextsObject = ACEHighwayManifestTranslationText()
  const commonTranslatedTextsObject = NaCommonTranslationText()

  async function onSubmit(data) {
    const result = await methods.trigger()

    if (result) {
      onEditParties(data)

      methods.reset(data)
    }
  }

  return (
    <Card variant='outlined'>
      <Box padding={2}>
        <FormProvider {...methods}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <PartiesFormProperties.Fields
                showNotification={showNotification}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container justify='space-between' spacing={2}>
                <Grid item xs='auto'>
                  <Grid container spacing={1}>
                    <Grid item xs='auto'>
                      <Tooltip placement='bottom' title={commonTranslatedTextsObject.addNew}>
                        <span>
                          <CngIconButton
                            icon={['fal', 'plus']}
                            onClick={() => onAddParties(initialValues)}
                            size='small'
                            type='outlined'
                          />
                        </span>
                      </Tooltip>
                    </Grid>
                    <Grid item xs='auto'>
                      <Tooltip placement='bottom' title={manifestTranslatedTextsObject.cloneButton}>
                        <span>
                          <CngIconButton
                            icon={['fal', 'copy']}
                            onClick={() =>
                              onAddParties({ ...parties, id: undefined })
                            }
                            size='small'
                            type='outlined'
                          />
                        </span>
                      </Tooltip>
                    </Grid>
                    {!isLast && (
                      <Grid item xs='auto'>
                        <Tooltip placement='bottom' title={manifestTranslatedTextsObject.deleteButton}>
                          <span>
                            <CngIconButton
                              icon={['fal', 'trash']}
                              onClick={() => onDeleteParties(parties)}
                              size='small'
                              type='outlined'
                            />
                          </span>
                        </Tooltip>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                {methods.formState.isDirty && (
                  <Grid item xs='auto'>
                    <Grid container spacing={2}>
                      <Grid item xs='auto'>
                        <CngButton
                          color='secondary'
                          onClick={() => methods.reset()}
                          size='medium'
                        >
                          {commonTranslatedTextsObject.reset}
                        </CngButton>
                      </Grid>
                      <Grid item xs='auto'>
                        <CngButton
                          color='primary'
                          onClick={methods.handleSubmit(onSubmit)}
                          size='medium'
                        >
                          {commonTranslatedTextsObject.saveChanges}
                        </CngButton>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </FormProvider>
      </Box>
    </Card>
  )
}

export default PartiesEntry
